import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { VIDEO_EVENTS } from 'playable';
export class YouTubeWrapper {
  constructor() {
    _defineProperty(this, "player", null);
    _defineProperty(this, "eventListeners", {
      [VIDEO_EVENTS.ERROR]: undefined,
      [VIDEO_EVENTS.CURRENT_TIME_UPDATED]: undefined
    });
  }
  setPlayer(player) {
    this.player = player;
  }
  callOnProgress(_ref) {
    var _this$eventListeners$, _this$eventListeners, _this$player;
    let {
      played,
      playedSeconds,
      loadedSeconds
    } = _ref;
    (_this$eventListeners$ = (_this$eventListeners = this.eventListeners)[VIDEO_EVENTS.CURRENT_TIME_UPDATED]) == null || _this$eventListeners$.call(_this$eventListeners, {
      duration: ((_this$player = this.player) == null ? void 0 : _this$player.getDuration()) || loadedSeconds,
      percent: played,
      seconds: playedSeconds
    });
  }
  callOnError(error) {
    var _this$eventListeners$2, _this$eventListeners2;
    (_this$eventListeners$2 = (_this$eventListeners2 = this.eventListeners)[VIDEO_EVENTS.ERROR]) == null || _this$eventListeners$2.call(_this$eventListeners2, error);
  }
  on(event, cb) {
    switch (event) {
      case VIDEO_EVENTS.CURRENT_TIME_UPDATED:
        this.eventListeners[VIDEO_EVENTS.CURRENT_TIME_UPDATED] = cb;
        break;
      case VIDEO_EVENTS.ERROR:
        this.eventListeners[VIDEO_EVENTS.ERROR] = cb;
        break;
      default:
        throw new Error(`event ${event} not supported`);
    }
  }
}
//# sourceMappingURL=YouTubeWrapper.js.map